<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('movement types')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/account/movement_type/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>
  <movement-type-modal ref="movement_type_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import MovementTypeModal from "./movement_type_modal/Index.vue";

export default {
  name: "MovementTypesDatatable",
  components: { GenericTable, MovementTypeModal },
  data() {
    let v = this;
    return {
      extra_buttons: [],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            if (row.behavior == "credit")
              return `<span class="icon has-text-success"><i class="fa fa-angle-right"></i></span> ${row.name}`;
            else if (row.behavior == "charge")
              return `<span class="icon has-text-danger"><i class="fa fa-angle-left"></i></span> ${row.name}`;
            else
              return `<span class="icon"><i class="fa fa-cubes"></i></span> ${row.name}`;
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.movement_type_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete movement type?"),
                    v,
                    () => {
                      del("/account/movement_type", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.movement_type_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
